'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../core/utils');

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateInputController = function DateInputController($scope) {
    var _this = this;

    _classCallCheck(this, DateInputController);

    this.dateOptions = {
        'startingDay': '1'
    };
    if (this.customClass) {
        this.dateOptions['customClass'] = this.customClass;
    }
    if (this.dateDisabled) {
        this.dateOptions['dateDisabled'] = this.dateDisabled;
    }

    $scope.$watch(function () {
        return _this.ngModel;
    }, function (val) {
        if ((0, _utils.parseISODate)(val)) {
            $scope.ngModel = (0, _utils.parseISODate)(val);
        }
    });

    $scope.$watch('ngModel', function (val) {
        _this.ngModel = (0, _utils.formatISODate)(val);
    });

    $scope.$watch(function () {
        return _this.min;
    }, function (min) {
        if (min) {
            Object.assign(_this.dateOptions, {
                minDate: min
            });
        }
    });

    $scope.$watch(function () {
        return _this.max;
    }, function (max) {
        if (max) {

            Object.assign(_this.dateOptions, {
                maxDate: max
            });
        }
    });

    $scope.$watch(function () {
        return _this.initDate;
    }, function (initDate) {
        if (initDate) {
            Object.assign(_this.dateOptions, {
                initDate: initDate
            });
        }
    });
};

DateInputController.$inject = ['$scope'];

_module3.default.component('dateInput', {
    bindings: {
        ngModel: '=',
        required: '@',
        ngReadonly: '<',
        ngChange: '<',
        min: '<',
        max: '<',
        initDate: '<',
        customClass: '<',
        dateDisabled: '<'
    },
    template: require('./dateInput.html'),
    controller: DateInputController
});


//////////////////
// WEBPACK FOOTER
// ./src/core/dateInput.js
// module id = 39
// module chunks = 0 2